import { useCallback, useContext } from 'react';
import { NotificationContext } from '../contexts/NotificationContext';
import { logger } from '../helpers/logger';
import { captureException } from '../sentry';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AuthenticatedRoutes } from '../routers/AuthenticatedRoutes';
import { UnverifiedAccountError } from '../types/UnverifiedAccountError';

export const useApiErrorHandler = () => {
  const { addNotification } = useContext(NotificationContext);
  const { t } = useTranslation('translation', { keyPrefix: 'apiError' });
  const history = useHistory();

  return useCallback((e: any, fallbackMessageKey = 'Something went wrong') => {
    if (e && typeof e === 'object' && e instanceof UnverifiedAccountError) {
      history.push(AuthenticatedRoutes.Unverified());
      return;
    }

    logger.error(e);
    captureException(e);

    let key =
      e?.response?.data?.reason ||
      (e?.response?.data?.message === 'Validation error' && e?.response?.data?.payload.join(', ')) ||
      (typeof e?.response?.data?.message === 'string' ? e.response.data.message : false) ||
      fallbackMessageKey;

    const errorMessageFromSwiftExceptionRegexp = /\[[a-zA-Z]+\.\d+:\s?(.+)\]\s*\[\/[a-zA-Z/]+\.swift:\d+:\d+\]/;
    if (typeof key === 'string') {
      const match = key.match(errorMessageFromSwiftExceptionRegexp);
      key = match ? match[1] : key;
    }

    addNotification({
      message: t(key, {
        nsSeparator: '###',
        defaultValue: key,
      }),
      severity: 'error',
    });
  }, []);
};
